var React = require('react');

function File (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.28782 0C7.40746 0 6.5571 0.350146 5.92684 0.980409L2.69549 4.22176C2.07523 4.84202 1.71508 5.69237 1.71508 6.57274V22.2893C1.71508 23.2297 2.48541 24 3.4258 24H20.5729C21.5133 24 22.2837 23.2297 22.2837 22.2893V1.72072C22.2937 0.780325 21.5233 0 20.5829 0H8.28782ZM7.71758 2.20092C8.03772 2.20092 8.28782 2.46103 8.28782 2.77115V4.86203C8.28782 5.80242 7.5175 6.57274 6.57711 6.57274H4.48624C4.16611 6.57274 3.916 6.31263 3.916 6.0025C3.916 5.85244 3.97603 5.70238 4.08607 5.60233C4.19612 5.50229 4.33618 5.43226 4.48624 5.43226H6.57711C6.89724 5.43226 7.14735 5.18216 7.14735 4.86203V2.77115C7.14735 2.62109 7.20737 2.47103 7.31742 2.37099C7.42746 2.27095 7.56752 2.20092 7.71758 2.20092Z","fill":"currentColor"}));
}

File.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = File;

File.default = File;
